<div class="status-message">
    <core-helpers-box-alert-message-icon 
        [text]="title"
        [icon]="typeMessage"
    ></core-helpers-box-alert-message-icon>
    <span *ngIf="description != undefined" class="status-description" [innerHTML]="description">{{description}}</span>
</div>

